export var getElement = function (element) {
    return element && 'current' in element ? element === null || element === void 0 ? void 0 : element.current : element;
};
